export default __webpack_public_path__ + "static/media/icon_facet_river.559b67a9.svg";